import React from 'react';

interface GlassInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  // extends native input props
}

/** Onboarding text field: sunken paper at rest, raised with a signal edge on focus. */
export const GlassInput = React.forwardRef<HTMLInputElement, GlassInputProps>(
  (props, ref) => {
    const { className = '', style, ...rest } = props;
    return (
      <input
        ref={ref}
        className={`w-full rounded-[10px] border border-line bg-paper-sunken px-5 py-4 text-ink outline-none transition-colors duration-200 ease-out placeholder:text-ink-3 focus:border-signal focus:bg-paper-raised ${className}`}
        style={{ fontSize: '16px', ...style }}
        {...rest}
      />
    );
  }
);

GlassInput.displayName = 'GlassInput';
